import { render, staticRenderFns } from "./PredictionList.vue?vue&type=template&id=84089e6c&"
import script from "./PredictionList.vue?vue&type=script&lang=js&"
export * from "./PredictionList.vue?vue&type=script&lang=js&"
import style0 from "./PredictionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports